import { FC } from "react";

import { CardContent } from "@mui/material"

import { Card, CardDescription, CardHeader, CardTitle } from "components/ui/card"
import { Skeleton } from "components/ui/skeleton"
 
export const AnalyticsLoadingBox: FC = () => {
  return (
    <Card className="min-h-[386px] max-h-[386px] p-[24px] shadow-none">
        <CardHeader className="p-0">
            <CardTitle>
                <Skeleton className="h-4 w-[10%]" />
            </CardTitle>
            <CardDescription className="flex flex-col gap-2">
                <Skeleton className="h-8 w-[20%]" />
                <Skeleton className="h-4 w-[30%]" />
            </CardDescription>
        </CardHeader>
        <CardContent >
        <Skeleton className="h-[200px] w-[100%] rounded-xl" />
        </CardContent>
    </Card>
  )
}